<template>
  <div class="flex-center">
    <div v-if="$slots.field" :id="'checkin-due-' + overdueType + id">
      <slot name="field"></slot>
    </div>
    <i class="pointer clock-icon mr-2" :id="'checkin-due-' + overdueType + id" v-else></i>
    <b-popover
      ref="popover"
      :target="'checkin-due-' + overdueType + id"
      delay="500"
      triggers="hover"
      placement="bottom"
      custom-class="text-medium text-center"
    >
      <div class="d-flex flex-column" style="max-width: 210px;">
        <div class="text-left" v-if="overdueType === 'kr'">Check-in on the KR is overdue</div>
        <div class="text-left" v-else>Some of the KRs in this Goal have missed Check-ins</div>
        <b-button
          @click="requestUpdate"
          variant="primary"
          class="text-small request-btn"
          :disabled="isRequesting"
        >
          <b-spinner small v-if="isRequesting"></b-spinner>
          <span v-else>Request an Update</span>
        </b-button>
        <div class="text-secondary text-small">An email will be sent to all owners</div>
      </div>
    </b-popover>
  </div>
</template>

<script>
import { trackEvent } from '@/analytics'
import { EVENT_ACTION, EVENT_CATEGORY, EVENT_NAME } from '@/constants/analytics'
import { BPopover, BButton, BSpinner } from 'bootstrap-vue'
import * as R from 'ramda'
import EventBus from '@/EventBus'
import { DEFAULT_ERROR } from '@/constants/messages'
import { TOAST_TYPE } from '@/constants/toasts'

export default {
  name: 'CheckinOverdue',
  props: {
    kr: {},
    goal: {},
    /**
     * used as identifier for popover target. If not provided, it considers kr/goal id
     */
    identifier: {}
  },
  components: {
    BPopover,
    BButton,
    BSpinner
  },
  data() {
    return {
      isRequesting: false
    }
  },
  computed: {
    overdueType() {
      return this.goal ? 'goal' : 'kr'
    },
    id() {
      return this.identifier || (this.goal || this.kr).id
    }
  },
  methods: {
    async requestUpdate() {
      const params = {}
      let action = 'requestGoalUpdate'
      if (this.overdueType === 'goal') {
        params.orgId = this.goal.organizationId
        params.goalId = this.goal.id
      } else {
        params.orgId = this.kr.organizationId
        params.goalId = this.kr.goalId
        params.krId = this.kr.id
        action = 'requestKrUpdate'
      }
      try {
        this.isRequesting = true
        await this.$store.dispatch(action, params)
        EventBus.$emit('ADD_TOAST', { message: 'Your update request is sent to all owners' })
        trackEvent(
          EVENT_CATEGORY.ACTIVITY,
          EVENT_ACTION.REQUEST_UPDATE_ICON,
          this.overdueType === 'goal' ? EVENT_NAME.GOAL : EVENT_NAME.KR
        )
        this.$refs.popover.$emit('close')
      } catch (e) {
        const message = R.pathOr(DEFAULT_ERROR, ['response', 'data', 'message'], e)
        EventBus.$emit('ADD_TOAST', { message, type: TOAST_TYPE.ERROR })
      }
      this.isRequesting = false
    }
  }
}
</script>

<style lang="scss" scoped>
.request-btn {
  padding: 2px 0;
  margin: 10px 0;
}
.clock-icon {
  filter: grayscale(1);
  transition: filter ease-in 300ms;
  &:hover {
    filter: grayscale(0);
  }
  /*pseudo element added to increase click area */
  &:after {
    content: ' ';
    width: 20px;
    height: 20px;
    display: block;
    transform: translate3d(-4px, -4px, 0);
  }
}
</style>
